"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Logo = props => {
  const {
    className,
    color = '#001871',
    width = '24px',
    height = '24px',
    ...others
  } = props;
  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
    className: className
  }, others), /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 222.14 247.17",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99,78.2L0,5.75l42.84,30.93-15.17,16.88,24.1,16.56,36.15-16.16-13.94-17.97L111.07,0l37.09,35.99-13.94,17.97,36.15,16.16,24.1-16.56-15.17-16.88,42.84-30.93-6.99,72.45H6.99ZM8.26,91.26l2.33,24.11h77.16s-.02,83.41-.02,83.41h-37.53c-8.37,0-15.61-6.46-15.61-13.98s7.99-14.03,16.78-19.06l-38.49-26.67,7.09,73.45,91.11,34.65,91.11-34.65,7.09-73.45-38.49,26.67c8.79,5.03,16.78,11.54,16.78,19.06,0,7.52-7.24,13.97-15.61,13.98h-37.53s-.02-83.41-.02-83.41h77.16s2.33-24.11,2.33-24.11H8.26Z",
    fill: color
  })));
};
var _default = exports.default = Logo;